import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-draw-right",
  "use": "icon-draw-right-usage",
  "viewBox": "0 0 20 15",
  "content": "<symbol fill=\"currentColor\" class=\"\" viewBox=\"0 0 20 15\" id=\"icon-draw-right\">\n  <path id=\"icon-draw-right_4469ced758951ca2b6aaeda354ba8a78-comm_icon_gou\" d=\"M1234.22-597.615l-6.584-5.628a1.524,1.524,0,0,1-.149-2.141,1.5,1.5,0,0,1,2.128-.15l5.438,4.648,9.417-10.834a1.5,1.5,0,0,1,2.128-.15,1.525,1.525,0,0,1,.149,2.141l-10.4,11.964a1.5,1.5,0,0,1-1.139.522A1.494,1.494,0,0,1,1234.22-597.615Z\" transform=\"translate(-1227.117 612.242)\" />\n\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol